import React, { useRef } from 'react';
import ReactSVG from 'react-svg';
import { ClickAwayListener } from '@material-ui/core';
import * as lib from '~/dependencies';
import { SearchIcon } from '~/assets/svgIcons';
import { PaperContainer, InputBaseContainer } from './styles';

export default function ContactsSearch({
  value,
  onChange,
  setContacts,
  searchApi,
  callback,
}) {
  const { t } = lib.useTranslation();

  const timeout = useRef(0);

  function findText(text) {
    onChange(text);

    if (searchApi) {
      // wait few seconds before to find in api
      if (timeout.current) clearTimeout(timeout.current);
      timeout.current = setTimeout(() => {
        setContacts(text);
      }, 500);
    }
  }

  function handleCallBack() {
    onChange('');
    callback(false);
  }

  return (
    <ClickAwayListener onClickAway={() => {}}>
      <PaperContainer>
        <InputBaseContainer
          autoFocus
          placeholder={t('components.contactsSearch.placeholder')}
          data-test-id="input-contacts-search"
          inputProps={{ 'aria-label': 'Search' }}
          value={value}
          onChange={e => findText(e.target.value)}
        />
        <ReactSVG onClick={handleCallBack} src={SearchIcon} className="icon" />
      </PaperContainer>
    </ClickAwayListener>
  );
}

ContactsSearch.defaultProps = {
  searchApi: true,
  setContacts: () => {},
};
ContactsSearch.propTypes = {
  value: lib.PropTypes.string.isRequired,
  onChange: lib.PropTypes.func.isRequired,
  setContacts: lib.PropTypes.func,
  searchApi: lib.PropTypes.bool,
  callback: lib.PropTypes.func.isRequired,
};
